import axios, { AxiosRequestConfig } from 'axios';
import { Store } from 'redux';
import IState from '../model/IState';
import { SetStocks } from '../actions/SetStocks';
import { IApi } from './IApi';
import Stock, { EmailMarketingSettings } from '../model/Stock';
import DashboardStock from '../model/DashboardStock';
import { StockName } from '../model/StockName';
import { Announcement } from '../model/Stock';
import { SendAnnouncementResult } from '../model/SendAnnouncementResult';
import { SaveAnnouncementResult } from '../model/SaveAnnouncementResult';
import { UpdateAnnouncementTagsResult } from '../model/UpdateAnnouncementTagsResult';
import SystemSettings from '../model/SystemSettingsViewModel';
import SaveStockResult from '../model/SaveStockResult';
import { GenerateReportRequest } from '../model/GenerateReportRequest';
import { GenerateReportResult } from '../model/GenerateReportResult';
import { AdminReportsView } from '../model/AdminReportsView';
import { ReportViewModel } from '../model/ReportViewModel';
import { AdminInvoiceResult } from '../model/AdminInvoiceResult';
import { LoginResult } from '../model/LoginResult';
import { SaveInvoiceDataRequest } from '../model/SaveInvoiceDataRequest';
import { FileCleanupResult } from '../model/FileCleanupResult';
import { MailChimpSubscriberCountResult } from '../model/MailChimpSubscriberCountResult';
import { SaveNoteRequest } from '../model/SaveNoteRequest';
import { SaveNoteResult } from '../model/SaveNoteResult';
import { GetNotesResult } from '../model/GetNotesResult';
import { SyncWatchlistResult } from '../model/SyncWatchlistResult';
import { XeroPageViewModel } from '../model/XeroPageViewModel';
import { AssignXeroInvoicesRequest } from '../model/AssignXeroInvoicesRequest';
import { ChangeTickerRequest, ChangeTickerResult } from '../model/ChangeTickerRequest';
import { to } from '../util/util';
import ServiceOption from '../model/ServiceOption';
import ServiceOrder from '../model/ServiceOrder';
import { GetServiceOrdersResult } from '../model/GetServiceOrdersResult';
import { CreateStockFromServiceOrderRequest, CreateStockFromServiceOrderResult } from '../model/CreateStockFromServiceOrderRequest';
import { CreateContactResult } from '../model/CreateContactResult';
import { CreateXeroRepeatingInvoiceResult } from '../model/CreateXeroRepeatingInvoiceResult';
import { ArchiveStockRequest, ArchiveStockResult } from '../model/ArchiveStockRequest';
import { DeleteAnnouncementResult } from '../model/DeleteAnnouncementResult';
import { ReconcileResult } from '../model/ReconcileResult';
import { MailChimpApiTestCampaignArgs } from '../model/MailChimpApiTestCampaignArgs';
import { DiskReportRequest, DiskReportResult } from '../model/DiskReportResult';
import { SaveEmailMarketingSettingsRequest, SaveEmailMarketingSettingsResult } from '../model/SaveEmailMarketingSettingsResult';
import { MailerooDnsRecordsResult } from '../model/MailerooDnsRecordsResult';
import { SendEmailRequest, SendEmailResult } from '../model/SendEmailRequest';
import { ResyncAnnouncementsResult } from '../model/ResyncAnnouncementsResult';
import { EmailMarketingApiResult } from '../model/EmailMarketingApiResult';
import { GetAnnouncementEditorHtmlResult } from '../model/GetAnnouncementEditorHtmlResult';
import { UpdateChartDataResult } from '../model/UpdateChartDataResult';
import { GetChartDataResult } from '../model/GetChartDataResult';
import { ClientGenerateReportRequest } from '../model/ClientGenerateReportRequest';
import { SendConfirmationAnnouncementEmailResult } from '../model/SendConfirmationAnnouncementEmailResult';
import { GenericHistoryViewModel } from '../model/GenericHistoryViewModel';
import { AnnouncementCommentResponseViewModel } from '../model/AnnouncementCommentResponseViewModel';
import { AnnouncementCommentResponseRequest, AnnouncementCommentResponseResult } from '../model/AnnouncementCommentResponseRequest';
import { AnnouncementCommentsResult } from '../model/AnnouncementCommentsResult';
import { GetUsersResult, SaveUserResult, EmailPasswordResult } from '../model/GetUsersResult';
import { GetUserResult, SaveUserRequest } from '../model/GetUserResult';
import { ClientDashboardResult } from '../model/ClientDashboardResult';
import { ClientStockResult } from '../model/ClientStockResult';
import { GetStockRefererResult } from '../model/StockReferer';
import { SaveClientStockRequest } from '../model/SaveClientStockRequest';
import { EmailMarketingCreateTemplateResult } from '../model/EmailMarketingCreateTemplateResult';
import { CampaignStatsResult } from '../model/CampaignStatsResult';
import { List, ContactListSummary, CreateContactListResult } from '../model/List';
import { GetTemplatesResult, SaveTemplatesResult, GetAnnouncementSummaryResult } from '../model/GetTemplatesResult';
import { Template } from '../model/Template';
import { MergeAnnouncementsRequest, MergeAnnouncementsResult } from '../model/MergeAnnouncementsRequest';
import { UploadContactCsvRequest, UploadContactCsvResult } from '../model/UploadContactCsvRequest';
import { UpdateContactListRequest, UpdateContactListResult } from '../model/UpdateContactListRequest';
import { GetFailedBatchSendEventsResult } from '../model/GetFailedBatchSendEventsResult';
import { MailerooBulkSendResult } from '../model/MailerooBulkSendResult';
import { GetCampaignResult, GetCampaignsResult } from '../model/GetCampaignsResult';
import { SendCampaignRequest, SendCampaignResult } from '../model/SendCampaignRequest';
import { SaveCampaignRequest, SaveCampaignResult } from '../model/SaveCampaignRequest';
import { RebateReportResult } from '../model/RebateReportResult';
import { HolderDetailsResult } from '../model/HolderDetailsResult';
import { RegisterListingResult } from '../model/RegisterListingResult';
import { TopHoldersResult } from '../model/TopHoldersResult';
import { RunHoldingsMovementReportResult, HoldingsMovementReportSummariesResult } from '../model/HoldingsMovementReportResults';
import { SaveShareRegistrySettingsRequest, SaveShareRegistrySettingsResult, SaveShareRegistryHoldingsMovementReportSettingsRequest, SaveShareRegistryHoldingsMovementReportSettingsResult } from '../model/SaveShareRegistrySettingsRequest';
axios.defaults.withCredentials = true;

class Api implements IApi {
    
    baseUrl:string = '';
    
    constructor(public store: Store<IState>) { 
        
        
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {                        
            this.baseUrl = 'http://localhost:5100';
        }        
    }

    getConfig(params?:{}) : AxiosRequestConfig {        
        
        let config:AxiosRequestConfig = {
            params
        }
        
        return config;
    }

    async getStocks(): Promise<DashboardStock[]> {

        const response = await this.get(`${this.baseUrl}/api/admin/stocks`);
        return response.data;
    }

    async getStockNames(): Promise<StockName[]> {
        const response = await this.get(`${this.baseUrl}/api/admin/stock-names`);
        return response.data;
    }
    
    async loadDashboardStocks(): Promise<void> {

        const stocks = await this.getStocks(); 
        this.store.dispatch(SetStocks(stocks));
    }

    async getStock(ticker:string): Promise<Stock> {
        const response = await this.get(this.getUrl(`/api/stock/${ticker}`));
        //await this.sleep(2500);
        return response.data;
    }
    
    async getFileCleanupResult(): Promise<FileCleanupResult> {
        const response = await this.get(this.getUrl(`/api/admin/fileCleanup`));
        return response.data;
    }

    async getDiskReportResult(request:DiskReportRequest): Promise<DiskReportResult> {
        const url = this.getUrl(`/api/admin/diskReport`);
        const response = await this.get(url, request);
        return response.data;
    }

    async getNewApiKey() : Promise<string> {
        const response = await this.get(this.getUrl(`/api/admin/apiKey`));
        return response.data;
    }

    async getInvoices(ticker:string) : Promise<AdminInvoiceResult> {
        const response = await this.get(this.getUrl(`/api/admin/invoices`), { ticker });
        return response.data;
    }

    async getXeroPage() : Promise<XeroPageViewModel> {
        const response = await this.get(this.getUrl(`/api/admin/getXeroPage`));
        return response.data;
    }

    async refreshXero() : Promise<XeroPageViewModel> {
        const response = await this.post(this.getUrl(`/api/admin/refreshXero`), {});
        return response.data;
    }

    async assignXeroInvoices(request:AssignXeroInvoicesRequest) : Promise<XeroPageViewModel> {        
        const response = await this.post(this.getUrl('/api/admin/assignXeroInvoices'), request);
        return response.data;
    }

    async syncWatchlist() : Promise<SyncWatchlistResult> {
        const response = await this.post(this.getUrl(`/api/admin/syncWatchlist`), {});
        return response.data;
    }

    async runPriorDay() : Promise<void> {
        await this.post(this.getUrl(`/api/admin/runPriorDay`), {});
    }

    async runHoldingsMovementReport(ticker:string, exchange:string, reportDate:string) : Promise<RunHoldingsMovementReportResult> {
        const response = await this.post(this.getUrl(`/api/ShareRegistry/runHoldingsMovementReport/${ticker}/${exchange}?reportDate=${reportDate}`), {});
        return response.data;
    }

    async getHoldingsMovementReportSummaries(ticker:string, exchange:string) : Promise<HoldingsMovementReportSummariesResult> {
        const response = await this.get(this.getUrl(`/api/ShareRegistry/holdingsMovementReportSummaries/${ticker}/${exchange}`));
        return response.data;
    }

    getHoldingsMovementReportUrl(ticker:string, exchange:string, reportDate:string) : string {
        return this.getUrl(`/api/ShareRegistry/holdingsMovementReport/${ticker}/${exchange}?reportDate=${reportDate}`);
    }

    async saveShareRegistrySettings(ticker:string, exchange:string, request:SaveShareRegistrySettingsRequest) : Promise<SaveShareRegistrySettingsResult> {
        const response = await this.post(this.getUrl(`/api/ShareRegistry/shareRegistrySettings/${ticker}/${exchange}`), request);
        return response.data;
    }

    async saveShareRegistryHoldingsMovementReportSettings(ticker:string, exchange:string, request:SaveShareRegistryHoldingsMovementReportSettingsRequest) : Promise<SaveShareRegistryHoldingsMovementReportSettingsResult> {
        const response = await this.post(this.getUrl(`/api/ShareRegistry/shareRegistryHoldingsMovementReportSettings/${ticker}/${exchange}`), request);
        return response.data;
    }

    async getRegisterListing(ticker:string, exchange:string) : Promise<RegisterListingResult> {
        const response = await this.get(this.getUrl(`/api/ShareRegistry/registerListing/${ticker}/${exchange}`));
        return response.data;
    }

    async getTopHolders(ticker:string, exchange:string) : Promise<TopHoldersResult> {
        const response = await this.get(this.getUrl(`/api/ShareRegistry/topHolders/${ticker}/${exchange}`));
        return response.data;
    }

    async getHolderDetails(ticker:string, exchange:string, params:{holderId?:string, holderNumber?:string, name?:string, holding?:string}) : Promise<HolderDetailsResult> {
        const query = new URLSearchParams(params as Record<string, string>).toString();
        const response = await this.get(this.getUrl(`/api/ShareRegistry/holderDetails/${ticker}/${exchange}?${query}`));
        return response.data;
    }

    async resyncAnnouncements(ticker:string) : Promise<ResyncAnnouncementsResult> {
        const response = await this.post(this.getUrl(`/api/admin/resyncAnnouncements?ticker=${ticker}`), {});
        return response.data;
    }

    async get(url:string, params?:{}) : Promise<any> {
        const [err, result ] = await to(axios.get(url, this.getConfig(params)))
        if(err){
            if(err.request && err.request.status===401){
                window.location.reload();
            }else{
                throw err;
            }            
            
        }else{
            return result;
        }
    }

    async sleep(ms: any): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    getUrl(path:string) : string {
        return `${this.baseUrl}${path}`;
    }

    async saveMarketData(ticker:string, marketData:any) : Promise<void>{
        return this.post(this.getUrl(`/api/admin/saveMarketData/${ticker}`), marketData);
    }

    async saveStockInvoiceData(request:SaveInvoiceDataRequest) : Promise<void>{
        return this.post(this.getUrl(`/api/admin/saveInvoiceData/${request.Ticker}`), request);
    }

    async saveStock(stock:Stock) : Promise<SaveStockResult> {
        const result = await this.post(this.getUrl(`/api/admin/stocks`), stock);        
        return result.data;
        // await this.sleep(2500);        
    }

     async post(url:string, payload:any) : Promise<any> {
        return await axios.post(url, payload, this.getConfig());
     }

    async deleteAnnouncement(ticker: string, announcement: Announcement): Promise<DeleteAnnouncementResult> {
        let result = await this.post(this.getUrl(`/api/Announcement/delete/${ticker}`), announcement);
        return result.data;
    }

    async sendAnnouncement(ticker: string, announcement: Announcement, sendOverride:boolean): Promise<SendAnnouncementResult> {
        let result = await this.post(this.getUrl(`/api/Announcement/send/${ticker}?sendOverride=${sendOverride}`), announcement);
        return result.data;
    }

    async updateAnnouncementTags(ticker: string, sendGuid: string, tags: string[]): Promise<UpdateAnnouncementTagsResult> {
        let result = await this.post(this.getUrl(`/api/Announcement/tags/${ticker}`), { sendGuid, tags });
        return result.data;
    }

    async saveAnnouncement(announcement:Announcement, existingAnnouncement:Announcement|null, file:File|null, ticker: string) : Promise<SaveAnnouncementResult> {
        const form = new FormData();

        if (file){
            form.append('file', file);
        }
          
        form.append('headline', announcement.headline);
        form.append('date', announcement.date);
        if(announcement.remotePath){
            form.append('remotePath', announcement.remotePath!);
        }
        
        if(existingAnnouncement){
          form.append('existingAnnouncementHeadline', existingAnnouncement.headline);
          form.append('existingAnnouncementDate', existingAnnouncement.date);
        }
        
        if (announcement.priceSensitive)
          form.append('priceSensitive', 'true');

        if (announcement.videoUrl)
            form.append('videoUrl', announcement.videoUrl);

        if (announcement.videoDescription)
            form.append('videoDescription', announcement.videoDescription);
            
        form.append('thumbnailPageNum', announcement.thumbnailPageNum +'');

        let result = await this.post(this.getUrl(`/api/Announcement/save/${ticker}`), form);
        return result.data
      }

      async getSystemSettings() : Promise<SystemSettings> {
        const result = await this.get(this.getUrl(`/api/admin/systemSettings`));        
        return result.data;
      }

      async saveSystemSettings(settings:SystemSettings) : Promise<SystemSettings> {
        const result = await this.post(this.getUrl(`/api/admin/systemSettings`), settings);        
        return result.data;
    }

    async generateReport(request: GenerateReportRequest): Promise<GenerateReportResult> {
        
        const form = new FormData()
        Object.keys(request).forEach((key) => {
            let value = (request as any)[key];
            if(value !== null){
                form.append(key, value)
            }
            
        })        
        console.log('request', request)
        let result = await this.post(this.getUrl(`/api/reports`), form);
        return result.data
    }

    async getReport(guid: string): Promise<ReportViewModel> {
        const result = await this.get(this.getUrl(`/api/report/${guid}`));
        return result.data;
    }

    async getReports(ticker: string): Promise<AdminReportsView> {
        const url = this.getUrl(`/api/reports`)
        const result = await this.get(url, { ticker });
        return result.data;
    }

    async login(username: string, password: string): Promise<LoginResult> {
        const config = {
            auth: {
                username,
                password,
            }
        };
        
        return axios.get(this.getUrl(`/api/login`), config);        
    }

    async refreshToken() : Promise<LoginResult> {        
        const result = await axios.get(this.getUrl('/api/admin/refreshtoken'))
        return result.data;
    }

    logout() : Promise<void> {
        return axios.delete(this.getUrl(`/api/login`))
    }


    async mailchimpSubscriberCount(apiKey:string, listId:string[], clientId:string, stockId:string, provider:string) : Promise<MailChimpSubscriberCountResult> {
        const q = new URLSearchParams();
        q.append('apiKey', apiKey);
        (listId || []).forEach(id => q.append('listId', id));
        q.append('clientId', clientId);
        q.append('stockId', stockId);
        q.append('provider', provider);
        const result = await this.get(`${this.getUrl('/api/EmailMarketingSubscriberCount')}?${q.toString()}`);
        return result.data;
    }

    async getNotes(ticker:string) : Promise<GetNotesResult> {
        const result = await this.get(this.getUrl(`/api/admin/getNotes`), { ticker })
        return result.data;
    }

    async getStockVersionHistory(ticker:string) : Promise<GenericHistoryViewModel> {
        const result = await this.get(this.getUrl(`/api/admin/getStockVersionHistory`), { ticker })
        return result.data;
    }

    async saveNote(request:SaveNoteRequest) : Promise<SaveNoteResult> {
        const result = await this.post(this.getUrl(`/api/admin/saveNote`), request);        
        return result.data;
    }
    
    async changeTicker(request:ChangeTickerRequest) : Promise<ChangeTickerResult> {
        const result = await this.post(this.getUrl(`/api/admin/changeTicker`), request);        
        return result.data;         
    }

    async getServiceOptions(groupId:number|undefined) : Promise<{ options: ServiceOption[]}> {
        const result = await this.get(this.getUrl('/api/serviceorder/services/'), { groupId } );        
        return result.data;         
    }
    async saveServiceOrder(order:ServiceOrder) : Promise<{ id: string, errors?: string[]}> {
        const result = await this.post(this.getUrl(`/api/serviceorder/`), order);
        return result.data;
    }

    async getServiceOrders() : Promise<GetServiceOrdersResult> {
        const result = await this.get(this.getUrl(`/api/admin/serviceOrders/`));        
        return result.data; 
    }

    async createStockFromServiceOrder(request:CreateStockFromServiceOrderRequest) : Promise<CreateStockFromServiceOrderResult> {
        const result = await this.post(this.getUrl(`/api/admin/createStockFromServiceOrder/`), request);        
        return result.data; 
    }
    async createContact(id:string) : Promise<CreateContactResult> {
        const result = await this.post(this.getUrl(`/api/admin/createContact?id=${id}`), null);    
        return result.data;            
    }

    async getServiceOrder(ticker:string) : Promise<ServiceOrder> {
        const result = await this.get(this.getUrl(`/api/admin/getServiceOrder`), { ticker });              
        return result.data;
    }

    async createXeroRepeatingInvoice(id:string, amount:number, isAnnual:boolean, billingDate:string) : Promise<CreateXeroRepeatingInvoiceResult> {
        const result = await this.post(this.getUrl(`/api/admin/createXeroRepeatingInvoice`), { id, amount, isAnnual, billingDate});
        return result.data;
    }

    async archiveStock(request:ArchiveStockRequest) : Promise<ArchiveStockResult> {
        const result = await this.post(this.getUrl(`/api/admin/archiveStock`), request);        
        return result.data;         
    }
    async reconcile(numDays:number) : Promise<ReconcileResult> {
        const result = await this.post(this.getUrl(`/api/reconcile/run?numDays=${numDays}`), {});        
        return result.data;         
    }
    async getReconcileResult(id:string) : Promise<ReconcileResult> {
        const result = await this.get(this.getUrl(`/api/reconcile/get/${id}`));        
        return result.data;         
    }
    async reconcileApply(id:string) : Promise<void> {
        const result = await this.post(this.getUrl(`/api/reconcile/apply/${id}`), {});        
        return result.data;         
    }
    async getLastReconcileId() : Promise<string> {
        const result = await this.get(this.getUrl(`/api/reconcile/last/`));        
        return result.data;         
    }
    async sendToSubscribers(args:MailChimpApiTestCampaignArgs) : Promise<SendAnnouncementResult> {
        const result = await this.post(this.getUrl(`/api/TestSendAnnouncement/sendToSubscribers`), args);        
        return result.data;         
    }
    async sendTestEmail(args:MailChimpApiTestCampaignArgs) : Promise<EmailMarketingApiResult> {
        const result = await this.post(this.getUrl(`/api/TestSendAnnouncement/sendTestEmail`), args);
        return result.data;
    }
    async getAnnouncementEditorHtml(combinedTicker:string, announcementGuid:string) : Promise<GetAnnouncementEditorHtmlResult> {
        const result = await this.post(this.getUrl(`/api/AnnouncementEditor/${encodeURIComponent(combinedTicker)}/${announcementGuid}/html`), {});
        return result.data;
    }
    async sendAnnouncementEditorPreview(combinedTicker:string, announcementGuid:string, html:string, subject:string, testEmailAddresses:string) : Promise<SendCampaignResult> {
        const result = await this.post(this.getUrl(`/api/AnnouncementEditor/${encodeURIComponent(combinedTicker)}/${announcementGuid}/sendPreview`), { html, subject, testEmailAddresses });
        return result.data;
    }
    async sendAnnouncementEditorCampaign(combinedTicker:string, announcementGuid:string, html:string, subject:string) : Promise<SendCampaignResult> {
        const result = await this.post(this.getUrl(`/api/AnnouncementEditor/${encodeURIComponent(combinedTicker)}/${announcementGuid}/sendCampaign`), { html, subject });
        return result.data;
    }
    async getWelcomeEmailTemplate(combinedTicker:string) : Promise<GetAnnouncementEditorHtmlResult> {
        const result = await this.get(this.getUrl(`/api/SendWelcomeEmail/${encodeURIComponent(combinedTicker)}/template`));
        return result.data;
    }
    async sendWelcomeEmail(combinedTicker:string, email:string, name:string, subject:string, html:string) : Promise<SendCampaignResult> {
        const result = await this.post(this.getUrl(`/api/SendWelcomeEmail/${encodeURIComponent(combinedTicker)}/send`), { email, name, subject, html });
        return result.data;
    }
    async createTemplate(args:MailChimpApiTestCampaignArgs) : Promise<EmailMarketingCreateTemplateResult> {
        const result = await this.post(this.getUrl(`/api/TestSendAnnouncement/createTemplate`), args);        
        return result.data;         
    }
    async getEmailMarketingSettings(id:string) : Promise<EmailMarketingSettings> {
        const result = await this.get(this.getUrl('/api/emailMarketingSettings/'), { id });        
        return result.data;         
    }
    async saveEmailMarketingSettings(request:SaveEmailMarketingSettingsRequest) : Promise<SaveEmailMarketingSettingsResult> {
        const result = await this.post(this.getUrl('/api/emailMarketingSettings/'), request);
        return result.data;
    }
    async getMailerooDnsRecords(domain:string) : Promise<MailerooDnsRecordsResult> {
        const result = await this.get(this.getUrl('/api/mailerooDnsRecords/'), { domain });
        return result.data;
    }
    async sendEmail(request:SendEmailRequest) : Promise<SendEmailResult> {
        const result = await this.post(this.getUrl('/api/admin/sendEmail'), request);        
        return result.data;         
    }
    async getExchanges() : Promise<string[]> {
        const result = await this.get(this.getUrl('/api/admin/exchanges/'));        
        return result.data;         
    }
    async getChartData(id:string) : Promise<GetChartDataResult> {
        const result = await this.get(this.getUrl('/api/admin/getChartData/'), { id });        
        return result.data;         
    }
    async updateChartData(id:string) : Promise<UpdateChartDataResult> {
        const result = await this.post(this.getUrl(`/api/admin/updateChartData/`), { id });        
        return result.data;         
    }
    async clientGenerateReportRequest(request:ClientGenerateReportRequest) : Promise<GenerateReportResult> {
        const result = await this.post(this.getUrl('/api/report/generateReport'), request);        
        return result.data;         
    }
    async sendConfirmationAnnouncementEmail(ticker: string, announcement: Announcement): Promise<SendConfirmationAnnouncementEmailResult> {
        let result = await this.post(this.getUrl(`/api/admin/sendConfirmationAnnouncementEmail/${ticker}`), announcement);
        return result.data;
    }
    async getAnnouncementCommentResponse(guid: string): Promise<AnnouncementCommentResponseViewModel> {
        const result = await this.get(this.getUrl(`/api/AnnouncementCommentResponse/${guid}`));
        return result.data;
    }
    async postAnnouncementCommentResponseRequest(request:AnnouncementCommentResponseRequest): Promise<AnnouncementCommentResponseResult> {
        let result = await this.post(this.getUrl(`/api/AnnouncementCommentResponse/${request.guid}`), request);
        return result.data;
    }
    async getAnnouncementCommentsResult(combinedTicker:string, announcementGuid:string|undefined) : Promise<AnnouncementCommentsResult> {
        const result = await this.get(this.getUrl('/api/AnnouncementComments/'), { combinedTicker,announcementGuid });        
        return result.data;         
    }
    async getUsers() : Promise<GetUsersResult> {
        const result = await this.get(this.getUrl('/api/users/'));        
        return result.data;         
    }
    async getUser(id:string) : Promise<GetUserResult> {
        const result = await this.get(this.getUrl(`/api/users/${id}`));        
        return result.data;         
    }
    async saveUser(id:string, user:SaveUserRequest) : Promise<SaveUserResult>{
        let result = await this.post(this.getUrl(`/api/users/${id}`), user);
        return result.data;
    }
    async emailPassword(id:string, password:string) : Promise<EmailPasswordResult>{
        let result = await this.post(this.getUrl(`/api/users/${id}/emailPassword`), { password });
        return result.data;
    }
    async getRebateReport(id:string, quarterOffset:number = 0) : Promise<RebateReportResult> {
        const result = await this.get(this.getUrl(`/api/users/${id}/rebateReport?quarterOffset=${quarterOffset}`));
        return result.data;
    }
    async getMyRebateReport(quarterOffset:number = 0) : Promise<RebateReportResult> {
        const result = await this.get(this.getUrl(`/api/clientDashboard/rebateReport?quarterOffset=${quarterOffset}`));
        return result.data;
    }
    async getClientDashboardResult() : Promise<ClientDashboardResult> {
        const result = await this.get(this.getUrl('/api/clientDashboard/'));        
        return result.data;         
    }
    async getClientStockResult(combinedTicker:string) : Promise<ClientStockResult> {
        const result = await this.get(this.getUrl('/api/ClientStock/'), { combinedTicker });        
        return result.data;         
    }
    async getReferers(stockId:string|undefined) : Promise<GetStockRefererResult> {
        const result = await this.get(this.getUrl('/api/admin/stockReferers'), { stockId });        
        return result.data;         
    }
    async saveClientStock(request:SaveClientStockRequest) : Promise<SaveStockResult> {
        const result = await this.post(this.getUrl(`/api/ClientStock`), request);        
        return result.data;         
    }
    async getCampaignStats(campaignId:string) : Promise<CampaignStatsResult> {
        const result = await this.get(this.getUrl('/api/CampaignStats'), { campaignId });        
        return result.data;         
    }
    async getContactList(stockId:string, listId?:string) : Promise<List> {
        const result = await this.get(this.getUrl('/api/ContactList'), { stockId, listId });
        return result.data;
    }
    async getContactLists(stockId:string) : Promise<ContactListSummary[]> {
        const result = await this.get(this.getUrl('/api/ContactList/Lists'), { stockId });
        return result.data;
    }
    async createContactList(stockId:string, name:string) : Promise<CreateContactListResult> {
        const result = await this.post(this.getUrl('/api/ContactList/CreateList'), { stockId, name });
        return result.data;
    }
    async getTemplates(stockId:string) : Promise<GetTemplatesResult> {
        const result = await this.get(this.getUrl('/api/Templates'), { stockId });        
        return result.data;         
    }
    async getAnnouncementSummary(stockId:string, localPath:string) : Promise<GetAnnouncementSummaryResult> {
        const result = await this.get(this.getUrl('/api/AnnouncementSummary'), { stockId, localPath });
        return result.data;
    }
    async getCampaignTemplates(stockId:string) : Promise<GetTemplatesResult> {
        const result = await this.get(this.getUrl('/api/CampaignTemplates'), { stockId });
        return result.data;
    }
    async saveTemplate(template:Template) : Promise<SaveTemplatesResult> {
        const result = await this.post(this.getUrl('/api/Templates'), template);        
        return result.data;         
    }
    async mergeAnnouncements(r:MergeAnnouncementsRequest) : Promise<MergeAnnouncementsResult> {
        const result = await this.post(this.getUrl('/api/admin/mergeAnnouncements'), r);        
        return result.data;         
    }
    async uploadContactCsv(request:UploadContactCsvRequest) : Promise<UploadContactCsvResult> {
        const form = new FormData();
        form.append('file', request.file);
        form.append('stockId', request.stockId);
        if (request.listId) form.append('listId', request.listId);

        let result = await this.post(this.getUrl(`/api/ContactList/UploadContactCsv`), form);
        return result.data
      }
    async updateContactList(request:UpdateContactListRequest) : Promise<UpdateContactListResult> {
        const result = await this.post(this.getUrl('/api/ContactList/Update'), request);
        return result.data;
      }
    async getFailedBatchSendEvents(campaignId:string) : Promise<GetFailedBatchSendEventsResult> {
        const result = await this.get(this.getUrl('/api/admin/failedBatchSendEvent'), { campaignId });        
        return result.data;         
    }
    async resendFailedBatchSendEvent(id:string) : Promise<MailerooBulkSendResult> {
        const url = this.getUrl(`/api/admin/resendFailedBatchSendEvent?id=${encodeURIComponent(id)}`);        
        const result = await this.post(url, {});        
        return result.data;        
    }
    async getCampaigns(stockId:string) : Promise<GetCampaignsResult> {
        const result = await this.get(this.getUrl('/api/campaign/list'), { stockId });        
        return result.data;         
    }
    async getCampaign(campaignId:string) : Promise<GetCampaignResult> {
        const result = await this.get(this.getUrl('/api/campaign'), { campaignId });        
        return result.data;         
    }
    async sendCampaign(request:SendCampaignRequest) : Promise<SendCampaignResult> {        
        const result = await this.post(this.getUrl(`/api/Campaign/send`), request);        
        return result.data;        
    }
    async saveCampaign(request:SaveCampaignRequest) : Promise<SaveCampaignResult> {        
        const result = await this.post(this.getUrl(`/api/Campaign/save`), request);        
        return result.data;        
    }
   
}
let instance: IApi;
export const setup = (store: any, api: IApi = new Api(store)) => {
    instance = api;
};
export default function get() {
    return instance;
};

export function getCombinedTicker(stock:Stock) : string {
    return `${combinedTicker(stock.ticker, stock.exchange)}`;
}
export function combinedTicker(ticker:string, exchange:string) : string {
    return `${ticker}:${exchange}`;
}